import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { useSummaryPdfDownload } from "../../Utils/useSummaryPdfDownload";
import Modal from "react-modal";
import { Tooltip } from "react-tooltip";

import Notification from "../../Components/Notification/Notification";
import { LoginButton } from "../Login/Login";

import { ORDER_STAGE } from "../../constants/orderForms";

import { FaAngleRight } from "react-icons/fa";
import { AiOutlineCheck, AiOutlineClose } from "react-icons/ai";
import greenTick from "../../Assets/images/greenTick.svg";
import redCross from "../../Assets/images/redCross.svg";
import hut from "../../Assets/images/hut.svg";
import logo from "../../Assets/images/LOGO.svg";
import exitIcon from "../../Assets/icons/exitIcon.svg";
import imagePlaceholderIcon from "../../Assets/images/imagePlaceholderIcon.png";
import printerIcon from "../../Assets/icons/printerIcon.svg";
import orderPlacedIcon from "../../Assets/icons/orderPlacedIcon.svg";
import { isImageFormatDisplayable } from "../../Utils/utility";
import OrderSummary from "../../Components/OrderSummary-Comps/OrderSummary";

function SmileDesignOrderConfirmation({
  orderFor,
  orderObjId,
  userInfo,
  userRole,
  setActiveTab,
  selectedServiceCategory,
  setIsDisclaimerAccepted,
  categoryObjId,
  isOrderPlaced = false,
  placeOrderHandler,
  orderByData,
}) {
  return (
    <div className="flex w-full">
      <OrderConfirmationTab
        orderObjId={orderObjId}
        userRole={userRole}
        userInfo={userInfo}
        setActiveTab={setActiveTab}
        selectedServiceCategory={selectedServiceCategory}
        setIsDisclaimerAccepted={setIsDisclaimerAccepted}
        isOrderPlaced={isOrderPlaced}
        placeOrderHandler={placeOrderHandler}
        categoryObjId={categoryObjId}
        orderByData={orderByData}
      />
    </div>
  );
}

export default SmileDesignOrderConfirmation;

export const OrderConfirmationTab = ({
  userInfo,
  userRole,
  orderObjId,
  setActiveTab,
  selectedServiceCategory,
  setIsDisclaimerAccepted,
  isOrderPlaced,
  placeOrderHandler,
  categoryObjId,
  orderByData,
}) => {
  const pdfRef = useRef();
  const navigate = useNavigate();

  const { smileOrderDetails } = useSelector((state) => state.orderFormDetails);
  const { user, isAuthenticated } = useAuth0();
  const { userProfileDetails } = useSelector((state) => state.personalDetails);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const openImageModal = (image) => {
    setSelectedImage(image);
    setIsImageModalOpen(true);
  };

  const closeImageModal = () => {
    setIsImageModalOpen(false);
  };

  const { downloadPDF, isDownloading } = useSummaryPdfDownload(pdfRef);

  return (
    <div className="MAIN-DASH bg-black md:p-4 px-4 pt-4 pb-20 w-full min-h-screen h-fit flex flex-col">
      <div className="NAVBAR flex justify-between items-center mb-4 ">
        <p className="text-[15px] text-[#999999] flex justify-between items-center">
          <img src={logo} className="mx-auto w-[50px] h-[40px] mr-4 block md:hidden" alt="" />
          <span>
            <img src={hut} alt="" />
          </span>
          <span className="ml-3">Dashboard</span>
        </p>
        <div className="flex gap-4 items-center">
          {isAuthenticated ? (
            <div className="text-[15px] justify-center items-center hidden md:flex text-white">
              Hello, {userProfileDetails?.firstName ?? user?.name}
            </div>
          ) : (
            <LoginButton />
          )}
          {userRole !== "89uij7" ? (
            userInfo?.length > 0 ? (
              <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                {userInfo[0]?.active === 1 ? (
                  <>
                    {userInfo[0]?.crowdHireId}
                    <img className="relative top-[4px] right-0" src={greenTick} alt="" />
                  </>
                ) : (
                  <div
                    className="flex"
                    data-tooltip-id="status"
                    data-tooltip-content={
                      "Your registration is under review and you will be notified once admin approves your registration."
                    }
                  >
                    <span className="text-orange-600">{userInfo[0]?.crowdHireId}</span>
                    <img
                      className="relative top-[0px] ml-2 right-0 h-5 w-5"
                      src={redCross}
                      alt=""
                    />
                    <Tooltip id="status" place="bottom" />
                  </div>
                )}
              </button>
            ) : (
              <button className="relative px-4 py-2 flex items-center rounded-xl bg-secondary font-medium text-[15px] text-white">
                Account Not Active
                <img className="relative top-[0px] right-0 h-5 w-5" src={redCross} alt="" />
              </button>
            )
          ) : (
            <></>
          )}

          <Notification />
        </div>
      </div>
      <div className="flex flex-col md:flex-row items-center justify-between gap-4 w-full bg-secondary px-4 rounded-t-xl py-4">
        <div>
          <p className="font-medium text-[34px] text-white">Crown and Bridge</p>

          {orderByData?.orderNumber && (
            <p className="text-white">
              Order Id : <strong className="text-primary">{orderByData?.orderNumber}</strong>
            </p>
          )}
        </div>
        {!isOrderPlaced && (
          <>
            <div onClick={downloadPDF} className="flex gap-4 items-center">
              {/* <img src={printerIcon} alt="" className="cursor-pointer" /> */}
              <button disabled={isDownloading} className="px-4 py-2 bg-[#FF7E00] rounded-md flex items-center gap-2 text-white font-medium disabled:opacity-60">
                <img src={exitIcon} alt="" />
                Download Summary
              </button>
            </div>
            <div className="flex items-center md:justify-end gap-4 flex-wrap">
              <button
                onClick={() => {
                  navigate("/orders");
                }}
                className="font-medium text-[17px] left-[18px] text-[#777] py-2 px-8 bg-white border border-opacity-50 rounded-xl"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  setActiveTab(ORDER_STAGE.DISCLAIMER);
                  setIsDisclaimerAccepted(false);
                }}
                className="font-medium text-[17px] left-[18px] text-[#777] py-2 px-8 bg-white border border-opacity-50 rounded-xl"
              >
                Back
              </button>
              <button
                onClick={() => {
                  placeOrderHandler();
                }}
                className="font-medium text-[17px] left-[18px] text-white py-2 px-8 bg-[#ff7e00] rounded-xl"
              >
                Get Quote
              </button>
            </div>
          </>
        )}
      </div>

      <OrderSummary
        data={{ ...smileOrderDetails, categoryObjId: [categoryObjId] }}
        transformDetails={false}
        isOrderPlaced={isOrderPlaced}
        ref={pdfRef}
      />
    </div>
  );
};
